export const detectBrowser = () => {
  const ua = navigator.userAgent;

  if (ua.includes("SEB") || ua.includes("SafeExamBrowser")) {
    return "Safe Exam Browser";
  }

  if (ua.includes("Edg/")) {
    return "Edge";
  }

  if (ua.includes("OPR") || ua.includes("Opera")) {
    return "Opera";
  }

  if (ua.includes("Chrome")) {
    return "Chrome";
  }

  if (ua.includes("Firefox")) {
    return "Firefox";
  }

  if (ua.includes("Safari")) {
    return "Safari";
  }

  if (ua.includes("Trident/") || ua.includes("MSIE")) {
    return "Internet Explorer";
  }

  return ua;
}